<!-- this component is reponsibble for both copy and paste the mail or uploading of emails described as recipient  -->
<template>
    <div class="container-fluid">
        <div class="" v-show="s1">
            <div class="row p-2">
                <div class="col-md-12">
                    <div class="contact-head">Copy and paste your contacts</div>
                    <p class="mt-2">Paste your contact information into this field.</p>
                    <div class="mb-3 mt-5">
                        <textarea name="" class="form-control" id="" cols="50" rows="15" :placeholder="placeholder"></textarea>
                    </div>
                </div>
                <div class="col-md-8">
                    <button class="btn btn-info">Continue to Organize</button>
                </div>

            </div>

        </div>
        <div class="" v-show="s2">
            <div class="row pr-5 px-5">
                <div class="col-12 col-md-12">
                    <div class="contact-head text-center">
                        Upload your CSV contacts
                    </div>
                </div>
              <!--  -->
                <div class="zone">
                    <div id="dropZ">
                        <i class="fa fa-cloud-upload"></i>
                        <div style="color:#0085A1">Drag and drop your file here</div>                    
                        <span>OR</span>
                        <div class="selectFile">       
                        <label for="file">Select CSV file</label>                   
                        <input type="file"  @change="uploadFile" id="file">
                        </div>
                        <!-- <p>File size limit : 10 MB</p> -->
                    </div>
                </div>
            <!--  -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data:()=>({
        s1 : false,
        s2 : false,
        placeholder:'Example web@email.com Firstname  LastName Middle'
    }),

    methods:{
       uploadFile(event){
           let input = event.target
           console.log(input.files)
            if (input.files) {
                let reader = new FileReader();
                reader.onload = (e) => {
                this.preview = e.target.result
                }
                this.image=input.files[0];
                reader.readAsDataURL(input.files[0]);
               
            }   
       }

    },
    created(){
        let param = this.$route.params.id
        if(param == 1){
            this.s1 = true
            
        }else if(param == 2){
            this.s2 = true
        }
    }
}
</script>


<style lang="css" scoped>
@import "https://fonts.googleapis.com/css?family=Poppins:300,400,500,600,700";
    .contact-head{
        font-size: 30px;
        font-weight: 400;
        font-family: 'Poppins';
    }
    textarea{
        font-family: 'Poppins';
    }
    .btn{
        border: none !important;
        border-radius: 0 !important;
        padding: 12px 70px;
        font-family: 'Poppins';
        font-size: 15px
        /* background-color: aquamarine; */
    }
    /* drag and drop css */

.zone {
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #e9e9e9;
  width: 80%;
  height: 50%;
  /* border: 5px dashed white; */
  text-align: center;
  color: white;
  z-index: 20;
  transition: all 0.3s ease-out;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.05), inset 0 0 0.25em 0 rgba(0, 0, 0, 0.25);
}
/* .zone .btnCompression .active {
  background: #eb6a5a;
  color: white;
} */
.zone i {
  text-align: center;
  font-size: 10em;
  color: #fff;
  margin-top: 50px;
}
.zone .selectFile {
  height: 50px;
  margin: 20px auto;
  position: relative;
  width: 200px;
}
.zone label,
.zone input {
  cursor: pointer;
  display: block;
  height: 50px;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  border-radius: 5px;
}
.zone label {
  background: #fff;
  color: #0085A1;
  display: inline-block;
  font-size: 1.2em;
  line-height: 50px;
  padding: 0;
  text-align: center;
  white-space: nowrap;
  text-transform: uppercase;
  font-weight: 400;
  box-shadow: 0 1px 1px gray;
}
.zone input[type="file"] {
  opacity: 0;
}
.zone.in {
  color: white;
  border-color: white;
  background: radial-gradient(ellipse at center, #eb6a5a 0, #c9402f 100%);
}
.zone.in i {
  color: #fff;
}
.zone.in label {
  background: #fff;
  color: #eb6a5a;
}
.zone.hover {
  color: gray;
  border-color: white;
  background: #fff;
  border: 5px dashed gray;
}
.zone.hover i {
  color: #eb6a5a;
}
.zone.hover label {
  background: #fff;
  color: #eb6a5a;
}
.zone.fade {
  transition: all 0.3s ease-out;
  opacity: 1;
}

</style>